document.addEventListener("DOMContentLoaded", () => {

    const widget = document.getElementById("sc-whatsapp-widget");
    if (!widget) return;

    const bubble = document.getElementById("scBubble");
    const card = document.getElementById("scCard");
    const close = document.getElementById("scClose");
    const whatsapp = document.getElementById("scWhatsappButton");

    const phone = widget.dataset.phone.replace(/\D/g, "");
    const message = widget.dataset.message;

    const STORAGE_KEY = "sc_widget_closed";

    const AUTO_OPEN = 3000;
    const AUTO_CLOSE = 15000;

    let timer;

    //----------------------------------------
    // Abrir
    //----------------------------------------

    function openWidget(){

        widget.classList.remove("is-hidden");
        widget.classList.add("is-open");

        resetTimer();

    }

    //----------------------------------------
    // Cerrar
    //----------------------------------------

    function closeWidget(){

        widget.classList.remove("is-open");
        widget.classList.add("is-hidden");

    }

    //----------------------------------------
    // Reiniciar contador
    //----------------------------------------

    function resetTimer(){

        clearTimeout(timer);

        timer = setTimeout(()=>{

            closeWidget();

        },AUTO_CLOSE);

    }

    //----------------------------------------
    // Recordar estado
    //----------------------------------------

    function saveClosed(){

        localStorage.setItem(STORAGE_KEY,"1");

    }

    function removeClosed(){

        localStorage.removeItem(STORAGE_KEY);

    }

    //----------------------------------------
    // Abrir automático
    //----------------------------------------

    if(!localStorage.getItem(STORAGE_KEY)){

        setTimeout(()=>{

            openWidget();

        },AUTO_OPEN);

    }

    //----------------------------------------
    // Burbuja
    //----------------------------------------

    bubble.addEventListener("click",()=>{

        openWidget();

        removeClosed();

    });

    //----------------------------------------
    // Botón cerrar
    //----------------------------------------

    close.addEventListener("click",(e)=>{

        e.stopPropagation();

        closeWidget();

        saveClosed();

    });

    //----------------------------------------
    // Reiniciar contador
    //----------------------------------------

    [
        "mousemove",
        "mouseenter",
        "touchstart",
        "click",
        "keydown"
    ].forEach(event=>{

        card.addEventListener(event,resetTimer);

    });

    //----------------------------------------
    // WhatsApp
    //----------------------------------------

    whatsapp.addEventListener("click",(e)=>{

        e.preventDefault();

        const url =
            "https://wa.me/" +
            phone +
            "?text=" +
            encodeURIComponent(message);

        window.open(url,"_blank");

    });

});